import React from 'react';
import Icon from 'src/components/icon';

import './avatar.scss';

const Avatar = ({ imageUrl, username }) => (
        <div className="Avatar">
            { imageUrl && (
                <img src={imageUrl} alt={username || 'Imagem de perfil'} />
            )}
            {
                !imageUrl && !username && (
                    <Icon
                        code="user"
                        color="white"
                        size={24}
                    />
                )
            }
            {
                !imageUrl && username && (
                    <div className="username">{username.substr(0, 1)}</div>
                )
            }
        </div>
);

export default Avatar;
